import { PageController } from '@client/components/_core/layout/PageController';
import { AnalysisHistory } from '@client/components/tools/document-analyzer/AnalysisHistory';
import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/console/$orgId/tools/document-analyzer/history')({
    staticData: {
        ui: {
            title: 'Document analysis history',
            subtitle: 'View and manage your previously analysed documents',
        },
        breadcrumb: {
            title: 'Analysis history',
        },
    },
    component: HistoryPage,
});

function HistoryPage() {
    return (
        <PageController route={Route}>
            <Outlet />
            <AnalysisHistory />
        </PageController>
    );
}
